import { Fragment } from 'react';
import * as S from './style';

type ProgramEntry =
	| { type: 'single'; time: string; content: string }
	| { type: 'double'; time: string; title: string; speaker: string }
	| { type: 'section'; content: string };

type ProgramDay = {
	title: string;
	entries: ProgramEntry[];
};

const conferenceTitle = '2026 한국노화학회 추계학술대회';
const conferenceTopic = 'Aging-Associated Cellular Remodeling and Tissue Dysfunction';

const programDays: ProgramDay[] = [
	{
		title: '프로그램',
		entries: [
			{ type: 'single', time: '13:00-13:20', content: '등록' },
			{ type: 'double', time: '13:20-13:30', title: '개회사', speaker: '이재원 회장 (부산대학교)' },
			{ type: 'section', content: 'Session I: 26년도 춘계학술대회 수상 기념 강연' },
			{ type: 'double', time: '13:30-14:00', title: 'Adipose-to-system metabolic communication', speaker: '서재명 (KAIST)' },
			{ type: 'double', time: '14:00-14:30', title: 'Complex Macromolecular Orchestration in Senescence and Aging', speaker: '강찬희 (서울대학교)' },
			{ type: 'single', time: '14:30-14:40', content: 'Coffee Break' },
			{ type: 'section', content: 'Session II: Cellular Remodeling and Functional Reprogramming in Aging' },
			{
				type: 'double',
				time: '14:40-15:05',
				title: 'Ultrastructural Remodeling of Astrocyte Mitochondria and Synapses in the Aging Hippocampus',
				speaker: '문지영 (한국뇌연구원)',
			},
			{
				type: 'double',
				time: '15:05-15:30',
				title: 'Regulation of Monocyte/Macrophage Function in Ischemic Stroke: Circulating Monocyte Priming and Metabolic Substrate Supply',
				speaker: '주현우 (한림대학교)',
			},
			{
				type: 'double',
				time: '15:30-15:55',
				title: 'Beyond immune decline: An old viral trick reveals how aging reprograms T cell fate',
				speaker: '최일규 (DGIST)',
			},
			{ type: 'single', time: '15:55-16:10', content: 'Coffee Break & Group Photo' },
			{ type: 'section', content: 'Session III: Cellular Senescence and Functional Decline in Chronic Organ Diseases' },
			{ type: 'double', time: '16:10-16:35', title: 'Targeting Senescent Stromal Cells in Lung Diseases', speaker: '이진영 (인하대학교)' },
			{ type: 'double', time: '16:35-17:00', title: 'Epigenetic Aging and Loss of Tubular Epithelial Identity in Kidney Disease', speaker: '정현수 (GIST)' },
			{
				type: 'double',
				time: '17:00-17:25',
				title: 'Tubular Senescence Impairs Renal Gluconeogenesis through FOXO1 Dysfunction',
				speaker: '정기웅 (부산대학교)',
			},
			{ type: 'double', time: '17:25-17:30', title: '폐회사', speaker: '이재원 회장 (부산대학교)' },
		],
	},
];

const Program = () => (
	<S.Container>
		<S.ContentTitle>프로그램</S.ContentTitle>
		<S.InfoBox>
			<S.InfoTitle>{conferenceTitle}</S.InfoTitle>
			<S.InfoRow>
				<span>주제</span>
				<strong>{conferenceTopic}</strong>
			</S.InfoRow>
		</S.InfoBox>
		<S.Wrapper>
			{programDays.map((day) => (
				<S.DaySection key={day.title}>
					<S.TableHead>{day.title}</S.TableHead>
					<S.Table>
						<S.TableHeadCell>Time</S.TableHeadCell>
						<S.TableHeadCell>Program</S.TableHeadCell>
						{day.entries.map((entry, index) => {
							if (entry.type === 'section') {
								return (
									<S.TableCell key={`${day.title}-section-${index}`} className="grid-column-1 center point bold">
										{entry.content}
									</S.TableCell>
								);
							}

							if (entry.type === 'double') {
								return (
									<Fragment key={`${day.title}-double-${index}`}>
										<S.TableCell className="bold" style={{ gridRow: 'span 2' }}>
											{entry.time}
										</S.TableCell>
										<S.TableCell className="program-title">{entry.title}</S.TableCell>
										<S.TableCell className="speaker">{entry.speaker}</S.TableCell>
									</Fragment>
								);
							}

							return (
								<Fragment key={`${day.title}-single-${index}`}>
									<S.TableCell className="bold">{entry.time}</S.TableCell>
									<S.TableCell>{entry.content}</S.TableCell>
								</Fragment>
							);
						})}
					</S.Table>
				</S.DaySection>
			))}
		</S.Wrapper>
	</S.Container>
);

export default Program;
